<template>
    <modal size="medium" :no-footer="true" @close="$emit('close')">
         <template slot="header">
            <strong>Import tenants to a cycle</strong>
        </template>

        <template slot="content">
            <p>Use the form below to import tentants to a cycle. Because cycles are facility-based, you may only upload tenants for a single facility at a time.</p>

            <div class="flex ai-c jc-sb">
                <label class="flex-0 ws-nw mr-3">Software Type:</label>
                <select-input class="flex-a"
                    :active-index="softwareInputData.activeIndex"
                    :choices="softwareInputData.choices"
                    @change="onChangeSoftware"></select-input>
            </div>

            <div class="mt-6">
                <label>Rent Roll (must be a .xlsx file)</label>
                <file-upload @change="(f) => files.rent_roll = f"></file-upload>

                <div v-show="activeSoftwareChoice.key === 'easystorage'">
                    <label class="mt-5">Tenant Address List (must be a .xlsx file)</label>
                    <file-upload @change="(f) => files.tenant_address_list = f"></file-upload>
                    <label class="mt-5">Insurance Sheet (must be a .xlsx file)</label>
                    <file-upload @change="(f) => files.insurance_sheet = f"></file-upload>
                </div>
            </div>

            <div class="flex ai-c jc-sb mt-6">
                <span>Note: If a file has multiple sheets, only the first sheet will be used.</span>

                <div class="flex jc-fe">
                    <div v-show="isLoadingUpload" class="flex ai-c mr-2">
                        <img src="@/assets/img/loading-black-32.gif" alt="loading" />
                    </div>

                    <button :disabled="uploadIsDisabled" type="button" @click="onUpload">Upload</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import http from "@/http"

export default {
    props: {
        cycleId: {
            required: true,
            type: Number
        }
    },

    data () {
        return {
            files: {
                insurance_sheet: null,
                rent_roll: null,
                tenant_address_list: null
            },
            isLoadingUpload: false,
            softwareInputData: {
                activeIndex: 1,
                choices: [
                    { key: "sitelink_web", label: "SiteLink - Web", badge: null },
                    { key: "sitelink_alp", label: "SiteLink - ALP", badge: null },
                    { key: "syrasoft", label: "Syrasoft", badge: null },
                    { key: "storedge", label: "Storedge", badge: null },
                    { key: "easystorage", label: "EasyStorage", badge: null }
                ]
            }
        }
    },

    computed: {
        /**
         * Return the full software choice object for the active index.
         *
         * @return object
         */
        activeSoftwareChoice () {
            return this.softwareInputData.choices[this.softwareInputData.activeIndex]
        },

        /**
         * Return true if the upload function should be disabled.
         *
         * @return boolean
         */
        uploadIsDisabled () {
            if (this.isLoadingUpload) {
                return true
            }

            switch (this.activeSoftwareChoice.key) {
            case "syrasoft":
                return !this.files.rent_roll
            case "sitelink_web":
                return !this.files.rent_roll
            case "sitelink_alp":
                return !this.files.rent_roll
            case "storedge":
                return !this.files.rent_roll
            case "easystorage":
                return !(this.files.rent_roll && this.files.tenant_address_list && this.files.insurance_sheet)
            }
        }
    },

    methods: {
        /**
         * When the software dropdown is changed, set the active option index.
         *
         * @param int index Selected option index
         */
        onChangeSoftware (index) {
            this.softwareInputData.activeIndex = index
        },

        /**
         * Upload the file to the server so the records can be added.
         */
        async onUpload () {
            const params = new FormData()

            this.isLoadingUpload = true
            this.result_counts = {}

            params.append("cycle_id", this.cycleId)
            params.append("software", this.activeSoftwareChoice.key)

            switch (this.activeSoftwareChoice.key) {
            case "syrasoft":
                params.append("rent_roll", this.files.rent_roll)
                break
            case "sitelink_web":
                params.append("rent_roll", this.files.rent_roll)
                break
            case "sitelink_alp":
                params.append("rent_roll", this.files.rent_roll)
                break
            case "storedge":
                params.append("rent_roll", this.files.rent_roll)
                break
            case "easystorage":
                params.append("rent_roll", this.files.rent_roll)
                params.append("tenant_address_list", this.files.tenant_address_list)
                params.append("insurance_sheet", this.files.insurance_sheet)
                break
            default:
                this.$modalManager.add({ state: "bad", header: "Error", body: `No such software as '${this.activeSoftwareChoice.label}'!` })
                this.isLoadingUpload = false
                return
            }

            try {
                const { data: response } = await http.post("/api/cycles/import-tenants", params)

                if (response === undefined) {
                    this.$modalManager.add({ state: "bad", header: "Error", body: "An unknown error occurred!" })
                } else {
                    if (response.duplicate_tenant_filename) {
                        const now = new Date()
                        const datestamp = `${now.getFullYear()}-${("0" + (now.getMonth() + 1)).slice(-2)}-${("0" + now.getDate()).slice(-2)}`

                        const url = `${http.defaults.baseURL}/api/exports/download?file_key=${response.duplicate_tenant_filename}&filename=duplicate_tenants_${datestamp}`

                        window.open(url, "_blank")
                    }

                    this.$emit("success", response)
                    this.$emit("close")
                }
            } catch (ex) {
                this.$modalManager.add({ state: "bad", header: "Error", body: ex })
            } finally {
                this.isLoadingUpload = false
            }
        }
    }
}
</script>

<style scoped>
>>> .modal-body {
    overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/manage-cycles-page/ImportTenantsModal.vue